import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid2,
  IconButton,
  Stack,
  Switch,
} from "@mui/material";
import DashboardLayout from "../../../../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../../../../components/MaterialTypography";
import MaterialInput from "../../../../../components/MaterialInput";
import MaterialBox from "../../../../../components/MaterialBox";
import { ArrowBack } from "@mui/icons-material";
import { useSearchParams } from "react-router-dom";
import MaterialButton from "../../../../../components/MaterialButton";
import DashboardFooter from "../../../../../layoutcontainers/DashboardLayout/components/Footer";
import {
  fetchData,
  fetchDataById,
  postData,
  putData,
} from "../../../../../services";
import { useEffect, useReducer, useState } from "react";
import { handelChange } from "../../../../../reducers/formReducer";
import MaterialSelect from "../../../../../components/MasterSelect";
import { useSnackbar } from "../../../../../context/popup";
import { useLoading } from "../../../../../components/Loading";
import DropDownConfig from "../../../../Utils/DropDownConfig";

const initialState = {
  MotorVariant: {},
  MotorVariantErr: "unchecked",
  insurerModel: {},
  insurerModelErr: "unchecked",
  insurerFuel: {},
  insurerFuelErr: "unchecked",
  insurerBodyType: {},
  insurerBodyTypeErr: "unchecked",
  insurerBodyStyle: {},
  insurerBodyStyleErr: "unchecked",
  generalInsurer: {},
  generalInsurerErr: "unchecked",
  engineCapacity: "",
  engineCapacityErr: "unchecked",
  seatCapacity: "",
  seatCapacityErr: "unchecked",
  carryingCapacity: "",
  carryingCapacityErr: "unchecked",
  wheels: "",
  wheelsErr: "unchecked",
  launchYear: "",
  launchYearErr: "unchecked",
  code: "",
  codeErr: "unchecked",
  name: "",
  nameErr: "unchecked",
  active: true,
};

const AddInsurerVariant = () => {
  const { showSnackbar } = useSnackbar();
  const { setCircleLoading } = useLoading();
  const [state, dispatch] = useReducer(handelChange, initialState);
  const [dropdown, setDropdown] = useState({
    variantId: [],
    insurer: [],
    modelId: [],
    fuelId: [],
    bodyType: [],
    bodyStyle: [],
  });

  const [searchParams] = useSearchParams();
  const Id = searchParams.get("id");
  const pageType = searchParams.get("pageType");

  const pageMode =
    pageType === "view" ? "view" : pageType === "edit" ? "edit" : "add";

  useEffect(() => {
    const fetchInsurerList = async () => {
      setCircleLoading(true);
      try {
        const response = await fetchData(
          `/reference/general/insurer-master?dropdown=true`
        );

        setDropdown((prev) => ({
          ...prev,
          insurer: response?.data?.items?.map((item) => ({
            value: item?.id,
            label: item?.companyName,
          })),
        }));
      } catch (error) {
        console.error("Error Fetching Data:", error);
      } finally {
        setCircleLoading(false);
      }
    };
    const fetchMotorVariantList = async () => {
      setCircleLoading(true);
      try {
        const response = await fetchData(`/reference/motor/mmv/variants?dropdown=true`);

        setDropdown((prev) => ({
          ...prev,

          variantId: response?.data?.items?.map((item) => ({
            value: item?.id,
            label: item?.name,
          })),
        }));
      } catch (error) {
        console.error("Error Fetching Countries:", error);
      } finally {
        setCircleLoading(false);
      }
    };

    const fetchInsurerModel = async () => {
      setCircleLoading(true);
      try {
        const response = await fetchData(`/reference/insurer/model?dropdown=true`);

        setDropdown((prev) => ({
          ...prev,
          modelId: response?.data?.items?.map((item) => ({
            value: item?.id,
            label: item?.name,
          })),
        }));
      } catch (error) {
        console.error("Error Fetching Countries:", error);
      } finally {
        setCircleLoading(false);
      }
    };

    const fetchInsurerFuel = async () => {
      setCircleLoading(true);
      try {
        const response = await fetchData(
          `/reference/insurer/key_value_store?dropdown=true&code=${DropDownConfig?.insurerFuelType}`
        );

        setDropdown((prev) => ({
          ...prev,
          fuelId: response?.data?.items?.map((item) => ({
            value: item?.id,
            label: item?.keyName,
          })),
        }));
      } catch (error) {
        console.error("Error Fetching Countries:", error);
      } finally {
        setCircleLoading(false);
      }
    };

    const fetchInsurerBodyType = async () => {
      setCircleLoading(true);
      try {
        const response = await fetchData(`/reference/insurer/body-type?dropdown=true`);

        setDropdown((prev) => ({
          ...prev,
          bodyType: response?.data?.items?.map((item) => ({
            value: item?.id,
            label: item?.name,
          })),
        }));
      } catch (error) {
        console.error("Error Fetching Countries:", error);
      } finally {
        setCircleLoading(false);
      }
    };

    const fetchInsurerBodyStyle = async () => {
      setCircleLoading(true);
      try {
        const response = await fetchData(`/reference/insurer/body-style?dropdown=true`);

        setDropdown((prev) => ({
          ...prev,
          bodyStyle: response?.data?.items?.map((item) => ({
            value: item?.id,
            label: item?.name,
          })),
        }));
      } catch (error) {
        console.error("Error Fetching Countries:", error);
      } finally {
        setCircleLoading(false);
      }
    };

    fetchInsurerList();
    fetchMotorVariantList();
    fetchInsurerModel();
    fetchInsurerFuel();
    fetchInsurerBodyType();
    fetchInsurerBodyStyle();
  }, []);

  useEffect(() => {
    const fetchCountryById = async () => {
      setCircleLoading(true);
      try {
        const data = await fetchDataById(`/reference/insurer/variant/${Id}`);
        const responseData = data?.data?.variant;

        if (data?.success) {
          dispatch({
            type: "bulkUpdate",
            payload: {
              generalInsurer: {
                value: responseData?.gInsurerId,
                label: responseData?.gInsurerName,
              },
              MotorVariant: {
                value: responseData?.mVariantId,
                label: responseData?.mVariantName,
              },
              insurerModel: {
                value: responseData?.iModelId,
                label: responseData?.iModelName,
              },
              insurerFuel: {
                value: responseData?.iFuelTypeId,
                label: responseData?.iFuelTypeName,
              },

              insurerBodyType: {
                value: responseData?.iBodyTypeId,
                label: responseData?.iBodyTypeName,
              },
              insurerBodyStyle: {
                value: responseData?.iBodyStyleId,
                label: responseData?.iBodyStyleName,
              },
              engineCapacity: responseData?.engineCapacity,
              carryingCapacity: responseData?.carryingCapacity,
              seatCapacity: responseData?.seatCapacity,
              wheels: responseData?.wheels,
              launchYear: responseData?.launchYear,
              code: responseData?.code,
              name: responseData?.name,
              active: responseData?.isActive,
            },
          });
        }
      } catch (error) {
        console.error("Error fetching data by ID:", error);
      } finally {
        setCircleLoading(false);
      }
    };
    if (Id) {
      fetchCountryById();
    }
  }, [Id]);

  const handelSubmit = async () => {
    const payload = {
      gInsurerId: state?.generalInsurer?.value,
      mVariantId: state?.MotorVariant?.value,
      code: state?.code,
      name: state?.name,
      iModelId: state?.insurerModel?.value,
      iFuelTypeId: state?.insurerFuel?.value,
      iBodyTypeId: state?.insurerBodyType?.value,
      iBodyStyleId: state?.insurerBodyStyle?.value,
      engineCapacity: state?.engineCapacity,
      seatCapacity: state?.seatCapacity,
      carryingCapacity: state?.carryingCapacity,
      wheels: state?.wheels,
      launchYear: state?.launchYear,
      isActive: state?.active,
    };
    if (pageMode === "edit") {
      try {
        setCircleLoading(true);
        const response = await putData(`/reference/insurer/variant/${Id}`, payload);
        const responseMessage = response?.message;
        if (response?.success) {
          showSnackbar(responseMessage, "success");
          window.history.back();
        } else {
          showSnackbar(responseMessage, "error");
        }
      } catch (error) {
        showSnackbar(error?.response?.data?.message, "error");
      } finally {
        setCircleLoading(false);
      }
    } else {
      try {
        setCircleLoading(true);
        const response = await postData("/reference/insurer/variant", payload);
        const responseMessage = response?.message;
        if (response?.success) {
          showSnackbar(responseMessage, "success");
          window.history.back();
        } else {
          showSnackbar(responseMessage, "error");
        }
      } catch (error) {
        showSnackbar(error?.response?.data?.message, "error");
      } finally {
        setCircleLoading(false);
      }
    }
  };

  const checkAllFields = () => {
    let allowSubmit = false;

    if (
      state.generalInsurerErr === "success" &&
      state.MotorVariantErr === "success" &&
      state.insurerModelErr === "success" &&
      state.insurerFuelErr === "success" &&
      state.insurerBodyTypeErr === "success" &&
      state.insurerBodyStyleErr === "success" &&
      state.codeErr === "success" &&
      state.nameErr === "success" &&
      state.engineCapacityErr === "success" &&
      state.seatCapacityErr === "success" &&
      state.carryingCapacityErr === "success" &&
      state.wheelsErr === "success" &&
      state.launchYearErr === "success"
    ) {
      allowSubmit = false;
    } else {
      allowSubmit = true;
    }

    return allowSubmit;
  };

  return (
    <>
      <DashboardLayout>
        <Card sx={{ minHeight: 500 }}>
          <CardHeader
            title={
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="row" alignItems="center" spacing={1}>
                  <IconButton onClick={() => window.history.back()}>
                    <ArrowBack />
                  </IconButton>
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                      Variant Details
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                      Enter New Variant Details from around the world.
                    </MaterialTypography>
                  </Stack>
                </Stack>
              </Stack>
            }
          />

          <CardContent>
            <Grid2 container spacing={2}>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    General Insurer <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="generalInsurer"
                  options={dropdown?.insurer}
                  value={state?.generalInsurer}
                  onChange={(e) =>
                    dispatch({
                      type: "Select",
                      value: e,
                      name: "generalInsurer",
                    })
                  }
                  success={state?.generalInsurerErr === "success"}
                  error={state.generalInsurerErr === "error"}
                  isDisabled={pageMode === "view"}
                />
              </Grid2>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Motor variant <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  options={dropdown?.variantId}
                  value={state?.MotorVariant}
                  onChange={(e) =>
                    dispatch({
                      type: "Select",
                      value: e,
                      name: "MotorVariant",
                    })
                  }
                  success={state?.MotorVariantErr === "success"}
                  error={state.MotorVariantErr === "error"}
                  isDisabled={pageMode === "view"}
                />
              </Grid2>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Insurer Model <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  options={dropdown?.modelId}
                  value={state?.insurerModel}
                  onChange={(e) =>
                    dispatch({
                      type: "Select",
                      value: e,
                      name: "insurerModel",
                    })
                  }
                  success={state?.insurerModelErr === "success"}
                  error={state.insurerModelErr === "error"}
                  isDisabled={pageMode === "view"}
                />
              </Grid2>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Insurer Fuel Type <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  options={dropdown?.fuelId}
                  value={state?.insurerFuel}
                  onChange={(e) =>
                    dispatch({
                      type: "Select",
                      value: e,
                      name: "insurerFuel",
                    })
                  }
                  success={state?.insurerFuelErr === "success"}
                  error={state.insurerFuelErr === "error"}
                  isDisabled={pageMode === "view"}
                />
              </Grid2>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Insurer Body Type <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  options={dropdown?.bodyType}
                  value={state?.insurerBodyType}
                  onChange={(e) =>
                    dispatch({
                      type: "Select",
                      value: e,
                      name: "insurerBodyType",
                    })
                  }
                  success={state?.insurerBodyTypeErr === "success"}
                  error={state.insurerBodyTypeErr === "error"}
                  isDisabled={pageMode === "view"}
                />
              </Grid2>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Insurer Body Style <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  options={dropdown?.bodyStyle}
                  value={state?.insurerBodyStyle}
                  onChange={(e) =>
                    dispatch({
                      type: "Select",
                      value: e,
                      name: "insurerBodyStyle",
                    })
                  }
                  success={state?.insurerBodyStyleErr === "success"}
                  error={state.insurerBodyStyleErr === "error"}
                  isDisabled={pageMode === "view"}
                />
              </Grid2>

              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Code <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="code"
                  value={state?.code}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "code",
                      type: "input",
                      regex: "^([\\s\\S]{1,20})$",
                    })
                  }
                  success={state?.codeErr === "success"}
                  error={state.codeErr === "error"}
                  disabled={pageMode === "view"}
                />
                {state.codeErr === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Code should be a minimum 1 character & maximum 20
                      characters long.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid2>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Name <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="name"
                  value={state?.name}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "name",
                      type: "input",
                      regex: "^([\\s\\S]{1,60})$",
                    })
                  }
                  success={state?.nameErr === "success"}
                  error={state.nameErr === "error"}
                  disabled={pageMode === "view"}
                />
                {state.nameErr === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Name should be a minimum 1 character & maximum 60
                      characters long.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid2>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Engine Capacity <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="engineCapacity"
                  value={state?.engineCapacity}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "engineCapacity",
                      type: "input",
                      regex: "^[0-9]+$",
                    })
                  }
                  success={state?.engineCapacityErr === "success"}
                  error={state.engineCapacityErr === "error"}
                  disabled={pageMode === "view"}
                />
                {state.engineCapacityErr === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please enter a valid integer.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid2>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Seat Capacity <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="seatCapacity"
                  value={state?.seatCapacity}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "seatCapacity",
                      type: "input",
                      regex: "^[0-9]+$",
                    })
                  }
                  success={state?.seatCapacityErr === "success"}
                  error={state.seatCapacityErr === "error"}
                  disabled={pageMode === "view"}
                />
                {state.seatCapacityErr === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please enter a valid integer.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid2>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Carrying Capacity <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="carryingCapacity"
                  value={state?.carryingCapacity}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "carryingCapacity",
                      type: "input",
                      regex: "^[0-9]+$",
                    })
                  }
                  success={state?.carryingCapacityErr === "success"}
                  error={state.carryingCapacityErr === "error"}
                  disabled={pageMode === "view"}
                />
                {state.carryingCapacityErr === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please enter a valid integer.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid2>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Wheels <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="wheels"
                  value={state?.wheels}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "wheels",
                      type: "input",
                      regex: "^[0-9]+$",
                    })
                  }
                  success={state?.wheelsErr === "success"}
                  error={state.wheelsErr === "error"}
                  type="number"
                  disabled={pageMode === "view"}
                />
                {state.wheelsErr === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please enter a valid integer.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid2>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Launch Year <span className="span">*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="launchYear"
                  value={state?.launchYear}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "launchYear",
                      type: "input",
                      regex: "^(?:19|20)d{2}$",
                    })
                  }
                  success={state?.launchYearErr === "success"}
                  error={state.launchYearErr === "error"}
                  disabled={pageMode === "view"}
                />
                {state.launchYearErr === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Invalid year format. Enter a 4-digit year between 1900 and
                      2099.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid2>
              <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                <MaterialBox>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Active
                  </MaterialTypography>
                </MaterialBox>
                <FormControlLabel
                  control={
                    <Switch
                      checked={state?.active}
                      onChange={() =>
                        dispatch({
                          type: "switch",
                          name: "active",
                          value: !state?.active,
                        })
                      }
                      color="primary"
                      disabled={pageMode === "view"}
                    />
                  }
                  label={
                    <MaterialTypography variant="caption" fontWeight="bold">
                      {state?.active ? "Active" : "Inactive"}
                    </MaterialTypography>
                  }
                />
              </Grid2>
            </Grid2>
          </CardContent>
          <MaterialBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            {pageMode !== "view" && (
              <>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="outlined"
                  color="dark"
                  onClick={() => window.history.back()}
                >
                  Cancel
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  disabled={checkAllFields()}
                  onClick={handelSubmit}
                >
                  {pageMode === "add" ? "Submit" : "Edit"}
                </MaterialButton>
              </>
            )}
          </MaterialBox>
        </Card>
      </DashboardLayout>
      <DashboardFooter />
    </>
  );
};

export default AddInsurerVariant;
